import React, { useEffect } from 'react';
import Select from 'react-select';

const options = [
  { value: 'PMAY', label: 'PMAY' },
  { value: 'Narega', label: 'NAREGA' },
  { value: 'PMGSY', label: 'PMGSY' },
];

export default function SchemeInput(props) {
  const handleChange = (newScheme) => {
    props.handleChange(undefined, newScheme.value, undefined);
  }
  // useEffect(() => {
  //   props.handleChange(undefined, options[0].value, undefined);
  // }, [])
  return (
    <div >
      <h1> Scheme</h1>
      <Select
        onChange={handleChange}
        options={options}
      />
    </div>
  );
}